// src/store/deliveryDetail.js
export default {
  namespaced: true,
  state: () => ({
    details: {} // { [deliveryId]: detalle }
  }),
  mutations: {
    setDetail(state, { deliveryId, detail }) {
      state.details = { ...state.details, [deliveryId]: detail }
    }
  },
  getters: {
    getDetail: (state) => (deliveryId) => state.details[deliveryId]
  }
}
